import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Select Your Games",
    description: "Select the 7 games you'd like to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect your Orlando Magic{" "}
        <Link
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://am.ticketmaster.com/magic/"
        >
          Account Manager
        </Link>{" "}
        using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets for each game in your plan will be available after purchase.
        Reach out to Orlando Magic support at{" "}
        <Link
          href="4078962442"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (407) 896-2442
        </Link>{" "}
        for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Magic 7-game plan work?",
    description:
      "Our customizable ticket plan puts the ball in your hands by letting you lock in great seats and save big while choosing the games you want. Simply review the home schedule and hand-select at least seven games, along with the seats you prefer for each one. Once you've picked seven or more games, you'll be all set to tip off your experience at Kia Center.",
  },
  {
    title: "Do I have to select all of my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "How do I choose my seats?",
    description:
      "You can choose from all current available inventory per game.",
  },
  {
    title: "Where are tickets delivered?",
    description:
      "Tickets will be delivered directly within the Orlando Magic App.",
  },
];

export const RegistrationTerms = () => (
  <>
    By checking the box you agree to receive notifications from the Orlando
    Magic and agree to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const CheckoutTerms = () => (
  <>
    By checking out you agree to receive notifications from the Orlando Magic
    and agree to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
